import React from 'react';
import PropTypes from 'prop-types';
import withInit from 'WithInit';

const LineBreak = props => (
  <div className="controls">
    <hr id={props.id} />
  </div>
);

LineBreak.propTypes = {
  id: PropTypes.string.isRequired,
};

export default withInit(LineBreak);



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/LineBreak.jsx